import React from "react";

// The Nerd Font icons in Sylvester's oh-my-posh prompt, drawn: the folder, the remote (GitHub), the
// branch, and whether the last command worked.

export const FolderGlyph = () => (
  <svg viewBox="0 0 12 10" fill="none" stroke="currentColor" strokeWidth="0.9" aria-hidden="true">
    <rect x="0.45" y="0.45" width="11.1" height="9.1" />
    <path d="M0.45 2.9h11.1M5.2 0.45v2.45" />
  </svg>
);

export const GitHubGlyph = () => (
  <svg viewBox="0 0 16 16" fill="currentColor" aria-hidden="true">
    <path d="M8 0C3.58 0 0 3.58 0 8c0 3.54 2.29 6.53 5.47 7.59.4.07.55-.17.55-.38 0-.19-.01-.82-.01-1.49-2.01.37-2.53-.49-2.69-.94-.09-.23-.48-.94-.82-1.13-.28-.15-.68-.52-.01-.53.63-.01 1.08.58 1.23.82.72 1.21 1.87.87 2.33.66.07-.52.28-.87.51-1.07-1.78-.2-3.64-.89-3.64-3.95 0-.87.31-1.59.82-2.15-.08-.2-.36-1.02.08-2.12 0 0 .67-.21 2.2.82.64-.18 1.32-.27 2-.27.68 0 1.36.09 2 .27 1.53-1.04 2.2-.82 2.2-.82.44 1.1.16 1.92.08 2.12.51.56.82 1.27.82 2.15 0 3.07-1.87 3.75-3.65 3.95.29.25.54.73.54 1.48 0 1.07-.01 1.93-.01 2.2 0 .21.15.46.55.38A8.01 8.01 0 0 0 16 8c0-4.42-3.58-8-8-8Z" />
  </svg>
);

export const BranchGlyph = () => (
  <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" aria-hidden="true">
    <circle cx="4.5" cy="12.5" r="1.6" />
    <circle cx="11.5" cy="3.5" r="1.6" />
    <path d="M4.5 2v8.9M11.5 5.1c0 3.4-7 3.1-7 6" />
  </svg>
);

export const CheckGlyph = () => (
  <svg viewBox="0 0 10 7" fill="none" stroke="currentColor" strokeWidth="1.1" aria-hidden="true">
    <path d="M0.6 3.3 3.6 6.2 9.4 0.6" />
  </svg>
);

export const CrossGlyph = () => (
  <svg viewBox="0 0 8 8" fill="none" stroke="currentColor" strokeWidth="1.1" aria-hidden="true">
    <path d="M0.8 0.8l6.4 6.4M7.2 0.8 0.8 7.2" />
  </svg>
);
